export enum PriceRestrictionType {
	PassiveMember = 0,
	ActiveMember = 1,
	AgeOver18 = 2,
	AgeUnder18 = 3,
	Standard = 4,
	NoMember = 5,
	Team = 6,
}
